import { render, staticRenderFns } from "./unifiedPrice.vue?vue&type=template&id=1730116c&scoped=true&"
import script from "./unifiedPrice.vue?vue&type=script&lang=js&"
export * from "./unifiedPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1730116c",
  null
  
)

export default component.exports